import { render, staticRenderFns } from "./CardItemSchool.vue?vue&type=template&id=49ee2581&scoped=true"
import script from "./CardItemSchool.vue?vue&type=script&lang=js"
export * from "./CardItemSchool.vue?vue&type=script&lang=js"
import style0 from "./CardItemSchool.vue?vue&type=style&index=0&id=49ee2581&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ee2581",
  null
  
)

export default component.exports